/**
 * Format order number for display
 * 
 * @param {string} orderNumber - Order number like "NEO-1700781234"
 * @returns {string} Formatted order number like "#NEO-1700781234"
 */
export const formatOrderNumber = (orderNumber) => {
  if (!orderNumber) return null;
  return orderNumber.startsWith('#') ? orderNumber : `#${orderNumber}`;
};

/**
 * Get order number from transaction
 * 
 * @param {Object} transaction - Transaction object
 * @returns {string|null} Order number or null
 */
export const getOrderNumber = (transaction) => {
  return transaction?.attributes?.protectedData?.orderNumber || null;
};

/**
 * Get formatted order number from transaction
 * 
 * @param {Object} transaction - Transaction object
 * @returns {string|null} Formatted order number like "#NEO-12345" or null
 */
export const getFormattedOrderNumber = (transaction) => {
  const orderNumber = getOrderNumber(transaction);
  return formatOrderNumber(orderNumber);
};

/**
 * Get order number to display (custom number or transaction UUID)
 * 
 * @param {Object} transaction - Transaction object
 * @returns {string} Order number "#NEO-12345" or transaction UUID
 */
export const getDisplayOrderNumber = (transaction) => {
  const customNumber = getOrderNumber(transaction);
  if (customNumber) {
    return formatOrderNumber(customNumber);
  }
  return transaction?.id?.uuid || 'N/A';
};

